export default "__VITE_ASSET__93bb6539__"